import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { AsyncSubject, Observable } from "rxjs";
import { saveAs } from 'file-saver';
import * as slug from "slug";
import { Case } from "../../cases/_types/case";
import { CaseInfo } from "../../cases/_types/case-info";
import { Transaction } from "../../transactions/_types/transaction";

@Injectable({
    providedIn: 'root',
})

export class PublicCaseService extends Service<Case> {
  public override type = 'caseInfo';
  public override url = 'attendance/public/case'; 

  public getCaseInfo(token: string): Observable<CaseInfo> {
    let url = this.getAPIUrl()+"/" + token;
    return this.http.get<CaseInfo>(url);
  }

  //¿esto?
  /*public getWorkerInfo(workerId: string): Observable<CaseInfo> {
    let url = this.getAPIUrl()+"/workers/" + workerId;
    return this.http.get<CaseInfo>(url);
  }*/

  public export(caseServiceId?: string, templateId?: string) {
    let url = this.getAPIUrl()+"/" + caseServiceId + '/' + templateId + '/export/pdf';    
    window.open(url, '_blank');
  }
}
